// Older geospatial anchors stored this dev-bucket map pin as their thumbnail.
// We no longer mint it; this matcher only recognises the legacy value so it is
// treated as "no image" everywhere: never seeded into a ScanImage, always
// eligible for thumbnail regeneration.
const LEGACY_GEOSPATIAL_PLACEHOLDER_PATH = '/system/location_on_map.png';

export function isPlaceholderThumbnailUrl(url: string | null | undefined): boolean {
  if (!url) return false;
  return url.includes(LEGACY_GEOSPATIAL_PLACEHOLDER_PATH);
}
